import React from "react";

const Tooltip = ({ text }) => (
  <span
    className="tooltip-icon"
    style={{
      marginLeft: 4,
      verticalAlign: "middle",
      cursor: "pointer",
      fontSize: 18
    }}
    title={text}
  >
    🛈
  </span>
);

export default Tooltip;